import initialiseNewRcb from './rcbV2';
import initialiseOldRcb from './rcbV1';

const ENABLE_NEW_RCB_PATHS = [];

window.addEventListener('load', () => {
  if (ENABLE_NEW_RCB_PATHS.includes(window.location.pathname)) {
    initialiseNewRcb();
  } else {
    initialiseOldRcb();
  }
});
